import en from './payLaterStrings.en';

export default { en };
